var _defs, _rect, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardDigital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgDigital",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31cc8d"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "url(#bgDigital)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320 160)",
    fill: "#ffffff",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -90,
    width: 120,
    height: 180,
    rx: 18,
    ry: 18,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: -74,
    width: 88,
    height: 120,
    rx: 6,
    ry: 6,
    fill: "#ffffff",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 70,
    r: 6,
    fill: "#ffffff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 290,
    textAnchor: "middle",
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 28,
    fontWeight: 800,
    fill: "#ffffff",
    letterSpacing: 2
  }, "DIGITAL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDigital);
export default __webpack_public_path__ + "static/media/card-digital.c6e0b3f0de807bdb6a7a46dcdeca1407.svg";
export { ForwardRef as ReactComponent };